module.exports = __webpack_public_path__ + "img/img17.d26b5a87.png";